/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var SortOrderEnum;

(function (SortOrderEnum) {
  SortOrderEnum["ASC"] = "ASC";
  SortOrderEnum["DESC"] = "DESC";
})(SortOrderEnum || (SortOrderEnum = {}));